"use client";

import React from "react";
import {
  IPackageDetailsExclusion,
  IPackageDetailsInclusion,
} from "../interface/IPackageDetails.interface";
import RichText from "@/utils/richText";
import { IPackageNotice } from "../../interface/IPackageData.interface";

interface IProps {
  inclusions: IPackageDetailsInclusion[];
  exclusions: IPackageDetailsExclusion[];
  notices: IPackageNotice[];
}

const Inclusions: React.FC<IProps> = ({ inclusions, exclusions, notices }) => {
  return (
    <section id="inclusions" className="w-full">
      <div className="flex items-center gap-4 mb-8 px-2">
        <h2 className="text-2xl font-black text-gray-900 uppercase tracking-tight">
          Trip Particulars
        </h2>
        <div className="h-[2px] flex-1 bg-gray-200" />
      </div>

      <div className="flex flex-col px-2">
        <div className="space-y-6">
          <div className="">
            <div className="flex items-center gap-3 mb-3">
              <span className="px-3 py-1 bg-tertiary-100 text-tertiary-700 text-[10px] font-black uppercase tracking-widest rounded-full">
                Good to Know
              </span>
              <div className="h-px flex-1 bg-tertiary-100" />
            </div>

            <ul className="grid grid-cols-1 gap-y-3">
              {notices?.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-3 group animate-in fade-in slide-in-from-left-4 duration-500 "
                >
                  <RichText
                    content={item?.description || ""}
                    className="text-gray-700 text-sm md:text-[15px] leading-relaxed prose prose-sm max-w-none prose-p:m-0"
                  />
                </li>
              ))}
            </ul>
          </div>

          <div className="">
            <div className="flex items-center gap-3 mb-3">
              <span className="px-3 py-1 bg-secondary-100 text-secondary-700 text-[10px] font-black uppercase tracking-widest rounded-full">
                What&apos;s Included
              </span>
              <div className="h-px flex-1 bg-secondary-100" />
            </div>

            <ul className="grid grid-cols-1 gap-y-3">
              {inclusions?.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-3 group animate-in fade-in slide-in-from-left-4 duration-500 "
                >
                  <RichText
                    content={item?.description || ""}
                    className="text-gray-700 text-sm md:text-[15px] leading-relaxed prose prose-sm max-w-none prose-p:m-0"
                  />
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="px-3 py-1 bg-rose-100 text-rose-700 text-[10px] font-black uppercase tracking-widest rounded-full">
                What&apos;s Excluded
              </span>
              <div className="h-px flex-1 bg-rose-100" />
            </div>

            <ul className="grid grid-cols-1 gap-y-3">
              {exclusions?.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-3 group animate-in fade-in slide-in-from-left-4 duration-500"
                >
                  <RichText
                    content={item?.description || ""}
                    className="text-gray-700 text-sm md:text-[15px] leading-relaxed prose prose-sm max-w-none prose-p:m-0"
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inclusions;
